// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__RueF9","bookNowBtnStyle":"AboutUs_bookNowBtnStyle__JbklF","footerStyle":"AboutUs_footerStyle__NPorb"};